import React from "react";
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import "./DashboardFormBlockModal.css"
import CheckBox from "/src/components/UI/CheckBox/CheckBox";
import Dropdown from "/src/components/UI/DropDown/DropDown"
import Tooltip from "../../Tooltip/Tooltip";
import { DashboardVariableTypeDropdown } from "../../../variableType"
import TextArea from "/src/components/UI/TextField/TextArea";
import useDropdownDashboard from "../../../hooks/useDropdownDashboard"
import { checkNumber } from "../../../checkNumber";

const DashboardFormBlockSlideVariable = ({ grid, setValue, stateFormGrid, watch, register }) => {
    const { dropdownDefaultValue, modifyDropdownValues } = useDropdownDashboard(grid?.placeholder_format);
    return (
        <div>
            <br />
            <div className={"dropdown_grid_slide_container title_container dropdown_dashboard_form_block_container"}>
                <Field label="Type variable" listLabelClassName="field-modal" ></Field>
                <div className="special_container_dashboard_grid_form">
                    <Dropdown {...register('type_variable', { valueAsNumber: true })} setValue={(name, value) => setValue("type_variable", value)} choices={DashboardVariableTypeDropdown} width="240px" defaultChoice={grid?.type_variable}></Dropdown>
                </div>
            </div>
            {
                watch('type_variable') == 0 &&
                <div className="checkbox_dashboard_variable_container title_container">
                    <Field label="Default value" listLabelClassName={"field-modal"} />
                    <div className="special_container_dashboard_grid_form">
                        <CheckBox  {...register('empty')} name={"default_value_checkbox"} onChange={(val) => setValue("default_value_checkbox", val.target.checked)} checked={grid?.type_variable == 0 ? parseInt(grid.default_value) : false}></CheckBox>
                    </div>
                </div>
            }
            {
                watch("type_variable") == 1 &&
                <div className={"title_container"}>
                    <Field label="Default value" listLabelClassName={"field-modal"} />

                    <TextInput {...register('default_value', { required: true, minLength: 1, maxLength: 200 })} defaultValue={stateFormGrid == 0 && grid?.default_value == "" ? "Valeur" : grid?.default_value} placeholder="Enter the default value" className={"input_variable_dashboard_form"} ></TextInput>
                </div>
            }
            {
                watch('type_variable') == 2 &&
                <div className="form_block_type_dropdown_container" style={{ marginTop: "40px" }}>
                    <div style={{ display: 'flex' }}>
                        <Field label="Variables in the dropdown" listLabelClassName="field-modal" />
                        <Tooltip classNameContainer={"top"} classNameBoxText="tooltip_upper" text={ <span>You have to put values like : <br/> Orange|Banana|Tomato separate with pipes |</span>}></Tooltip>
                    </div>
                    <TextInput {...register('value_dropdown')} onChange={(e) => { modifyDropdownValues(e.target.value), setValue("value_dropdown", e.target.value) }} onKeyUp={(e) => modifyDropdownValues(e.target.value)} placeholder="Example : Orange|Banana|Tomato" className={"input_variable_dashboard_form"} defaultValue={grid?.type_variable == 2 ? grid.placeholder_format : ""}></TextInput>
                </div>
            }
            {
                watch('type_variable') == 2 && dropdownDefaultValue.length > 0 &&
                <div className={"dropdown_grid_slide_container title_container dropdown_dashboard_form_block_container"}>
                    <Field label="Default value" listLabelClassName={"field-modal"} />
                    <div className="special_container_dashboard_grid_form">
                        <Dropdown key={Date.now()} {...register('default_value_dropdown', { valueAsNumber: true })} choices={dropdownDefaultValue} defaultChoice={grid?.type_variable == 2 ? grid.default_value : ""} width="240px" setValue={setValue} ></Dropdown>
                    </div>
                </div>

            }
            {
                watch('type_variable') == 4 &&
                <div className="title_container">
                    <Field label="Default value" listLabelClassName={"field-modal"} />
                    <div>
                        <TextInput type="number"  {...register('default_value_number', { required: true, minLength: 1 })} onKeyDown={(e) => checkNumber(e)} defaultValue={grid?.type_variable == 4 ? parseInt(grid.default_value) : ""} placeholder="Enter the default value number" className={"input_variable_dashboard_form"} />
                    </div>
                </div>
            }
            <div className="title_container">
                <Field label={<div> Regex {(watch('type_variable') == 1 ? "" : <span className="blockForm_disabled_field_message">Disabled</span>)}</div>} listLabelClassName="field-modal" />
                <TextArea  {...register('regex')} placeholder="Enter the complementary informations  of the variable" disabled={watch('type_variable') == 1 ? false : true} className={"input full-width resize-area text_area_dashboard_form_variable " + (watch('type_variable') == 1 ? "" : "text_area_disabled")} defaultValue={grid?.type_variable == 1 ? grid.regex : ""}></TextArea>
            </div>
            <div className="title_container">
                <Field label={<div> Error message indication {(watch('type_variable') == 1 ? "" : <span className="disabled_field_message">Disabled</span>)}</div>} listLabelClassName="field-modal" />
                <TextInput {...register('placeholder_format')} placeholder="Example : Don't insert special character" className={"input_variable_dashboard_form " + (watch('type_variable') == 1 ? "" : "text_area_disabled")} disabled={watch('type_variable') == 1 ? false : true} defaultValue={grid?.type_variable == 1 ? grid.placeholder_format : ""}></TextInput>
            </div>
        </div>
    )
};

export default DashboardFormBlockSlideVariable;